module.exports = __webpack_public_path__ + "group_buy/groupbuy_banner-bd4f206b1831c9b23ad44e61aab00c3c.png";